import { observer } from "mobx-react-lite";
import { FC } from "react";
import { Form } from "../AddUser/Form";
import { User } from "@/endpoints/dryp/user";
import { DialogDescription, DialogTitle } from "@radix-ui/react-dialog";
import { useStore } from "@/hooks/useStore";
import { DialogHeader } from "@/components/ui/dialog";

interface EditUserProps {
	user: User;
	onSuccess: () => void;
}

export const EditUser: FC<EditUserProps> = observer(({ user, onSuccess }) => {
	const {
		userStore,
		uiStore: { modalStore },
	} = useStore();
	const isOwnUser = userStore.getUser?.name === user.userName;
	console.log("userStore.getUser?.id", userStore.getUser);
	console.log("user.id", user.id);
	return (
		<>
			<DialogHeader>
				<DialogTitle>Edit User</DialogTitle>
				<DialogDescription className="sr-only">Fill out the form to edit user details.</DialogDescription>
			</DialogHeader>

			{isOwnUser ? (
				<p className="text-sm text-muted-foreground py-4">
					You cannot edit your own user. Please contact customer services for assistance.
				</p>
			) : (
				<Form
					title="Edit"
					defaultUserValues={user}
					onSuccess={() => {
						modalStore.close();
						onSuccess();
					}}
				/>
			)}
		</>
	);
});
